/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SCIMGroupMappingRead = {
  readonly id?: number;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  idp_group_id?: string | null;
  idp_group_name?: string | null;
  role: SCIMGroupMappingRead.role;
  scim_configuration: number;
};
export namespace SCIMGroupMappingRead {
  export enum role {
    '_0' = 0,
    '_2' = 2,
    '_4' = 4,
    '_5' = 5,
    '_6' = 6,
    '_7' = 7,
    '_8' = 8,
  }
}

